import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid,
    Snackbar,
    Alert,
    Modal, Backdrop, CircularProgress,
    TextField,
    Checkbox,
    FormControlLabel
} from '@mui/material';
import { Download } from '@mui/icons-material';
import axios from 'axios';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import 'moment/locale/pt';  // Importar a localidade para português
import '../App.css';


moment.locale('pt');


const Folhasdepresençav2 = () => {
    const [empregados, setEmpregados] = useState([]);
    const [selectedEmpregado, setSelectedEmpregado] = useState(null);
    const [ano, setAno] = useState(moment().year());
    const [mes, setMes] = useState(moment().month() + 1); // Mês atual
    const [selectedDates, setSelectedDates] = useState([]);
    const [horasExtras, setHorasExtras] = useState({
        totalSemana: 0,
        totalFimDeSemana: 0
    });
    const [ferias, setFerias] = useState([]);
    const [faltas, setFaltas] = useState([]);
    const [turno, setTurno] = useState('normal');
    const [empregadosAlterados, setEmpregadosAlterados] = useState([]);
    const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
    const [modalOpen, setModalOpen] = useState(false);
    const [isFullDay, setIsFullDay] = useState(false); // Novo estado para controlar a checkbox "Dia inteiro"
    const [alteredDays, setAlteredDays] = useState([]);
    const years = Array.from({ length: moment().year() - 2020 + 1 }, (_, i) => 2020 + i);
    const months = moment.months();
    const [loading, setLoading] = useState(false);
    const [newFalta, setNewFalta] = useState({
        dia: '',
        tipo_falta: 'injustificada', // Definir "Injustificada" como padrão
        horario_inicio: '',
        horario_fim: '',
        documento_justificacao: null,
    });
    const [isHolidayModalOpen, setIsHolidayModalOpen] = useState(false); // Controla a abertura e fechamento do modal
    const [holidayName, setHolidayName] = useState(''); // Armazena o nome do feriado inserido
    const [isHalfDay, setIsHalfDay] = useState(false); // Estado para controlar se é meio dia
    const [horasExtrasDates, setHorasExtrasDates] = useState([]); // Novo estado para armazenar datas de horas extras
    const [openAddModal, setOpenAddModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState(""); // Estado para armazenar o termo de pesquisa
    const [newHoraExtra, setNewHoraExtra] = useState({
        data: '',
        horas_trabalhadas: '',
        justificativa: '',
    });
    
    const [isMultiDaySelection, setIsMultiDaySelection] = useState(false); // Controle da checkbox
    const [manualHolidays, setManualHolidays] = useState([]); // Estado para armazenar feriados manualmente adicionados
    const [startDate, setStartDate] = useState(null); // Data de início para a seleção múltipla
    const [feriados, setFeriados] = useState([]); // Inicializa o estado dos feriados
    const [faltaModalOpen, setFaltaModalOpen] = useState(false); // Controla a abertura da modal da falta
    const [selectedFalta, setSelectedFalta] = useState(null); // Armazena os detalhes da falta selecionada

    const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local

    const csrfToken = document.cookie
  .split('; ')
  .find(row => row.startsWith('csrftoken'))
  ?.split('=')[1];

if (csrfToken) {
    axios.defaults.headers.common['X-CSRFToken'] = csrfToken;
} else {
    console.error('CSRF token not found');
}

    const handleOpenAddModal = () => {
        console.log("Modal de horas extras aberta");  // Adicione isso para verificar
        setOpenAddModal(true);
    };
    
    const handleMarkHoliday = () => {
        if (selectedDates.length) {
            setIsHolidayModalOpen(true);  // Abre o modal para inserir o nome do feriado
        } else {
            setAlert({ open: true, message: 'Selecione um dia primeiro!', severity: 'warning' });
        }
    };

    const handleCloseModals = () => {
        setOpenAddModal(false);
        setModalOpen(false); // Caso também queira fechar o modal de faltas
    };
    
    const handleNewHoraExtraChange = (e) => {
        setNewHoraExtra({
            ...newHoraExtra,
            [e.target.name]: e.target.value,
        });
    };
    const handleCloseHolidayModal = () => {
        setIsHolidayModalOpen(false);
        setHolidayName('');  // Limpa o nome do feriado ao fechar o modal
    };
    
    const fetchFeriados = async () => {
        const token = localStorage.getItem('access');
        try {
            const response = await axios.get(`${apiBaseURL}/api/feriados/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            
            // Formatar as datas dos feriados como objetos de data
            const fetchedFeriados = response.data.map(feriado => ({
                date: new Date(feriado.data),
                name: feriado.nome
            }));
            
            setFeriados(fetchedFeriados); // Armazena os feriados no estado
        } catch (error) {
            console.error('Erro ao buscar feriados:', error);
        }
    };

    const handleSaveHoliday = async () => {
        if (!holidayName) {
            alert('Por favor, insira o nome do feriado.');
            return;
        }
    
        const newHoliday = selectedDates[0]; // Selecionar a primeira data
        const formattedDate = moment(newHoliday).format('YYYY-MM-DD'); // Formatar a data para o formato YYYY-MM-DD
        
        // Log do payload a ser enviado
        console.log('Payload a ser enviado:', { nome: holidayName, data: formattedDate });
        
        try {
            const token = localStorage.getItem('access');
            
            // Log do token JWT
            console.log('Token JWT:', token);
    
            // Chamar a API para salvar o feriado
            const response = await axios.post(`${apiBaseURL}/api/feriados/`, {
                nome: holidayName, // Certifique-se de usar "nome"
                data: formattedDate // Certifique-se de usar "data"
            }, {
                headers: {
                    Authorization: `Bearer ${token}`, // Adicionar token para autenticação
                    'Content-Type': 'application/json',
                }
            });
    
            // Log da resposta da API
            console.log('Resposta da API:', response.data);
    
            // Atualizar o estado local com o novo feriado
            setManualHolidays([...manualHolidays, { date: newHoliday, name: holidayName }]);
    
            // Fechar o modal e limpar o nome
            setIsHolidayModalOpen(false);
            setHolidayName('');
            setAlert({ open: true, message: `Feriado ${holidayName} marcado com sucesso!`, severity: 'success' });
    
        } catch (error) {
            // Log do erro completo para investigar a causa do problema
            console.error('Erro ao marcar feriado:', error.response ? error.response.data : error.message);
            console.log('Erro completo:', error);
    
            setAlert({ open: true, message: 'Erro ao marcar feriado.', severity: 'error' });
        }
    };
    
    
    
    const handleAddHoraExtra = async () => {
        const token = localStorage.getItem('access');
        if (!newHoraExtra.data || !newHoraExtra.horas_trabalhadas) {
            setAlert({ open: true, message: 'Por favor, preencha todos os campos obrigatórios.', severity: 'warning' });
            return;
        }
    
        const payload = {
            empregado: selectedEmpregado.id,
            data: newHoraExtra.data,
            horas_trabalhadas: parseFloat(newHoraExtra.horas_trabalhadas),
            justificativa: newHoraExtra.justificativa,
            aprovado_por: null,
            data_aprovacao: null,
        };
    
        try {
            await axios.post(`${apiBaseURL}/api/horas-extras/`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setAlert({ open: true, message: 'Hora extra adicionada com sucesso!', severity: 'success' });
                        setOpenAddModal(false);
            fetchHorasExtras(selectedEmpregado.id, mes, ano);
        } catch (error) {
            console.error('Erro ao adicionar hora extra:', error.response ? error.response.data : error.message);
            setAlert({ open: true, message: 'Erro ao adicionar hora extra.', severity: 'error' });
                }
    };

    const fetchHorasExtras = async (empregadoId, mes, ano) => {
        const token = localStorage.getItem('access');
        try {
            const response = await axios.get(
                `${apiBaseURL}/api/horas-extras/?empregado=${empregadoId}&mes=${mes}&ano=${ano}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log('Payload recebido:', response.data);
            const horasExtrasData = response.data;
            
            // Filtrar os dados pelo mês e ano
            const horasExtrasFiltradas = horasExtrasData.filter(horaExtra => {
                const data = new Date(horaExtra.data);
                return data.getMonth() + 1 === mes && data.getFullYear() === ano; // +1 porque getMonth() retorna de 0 a 11
            });
    
            // Calcular horas extras durante a semana (segunda a sexta)
            const horasExtrasSemana = horasExtrasFiltradas
                .filter(horaExtra => {
                    const dayOfWeek = new Date(horaExtra.data).getDay();
                    return dayOfWeek >= 1 && dayOfWeek <= 5; // Segunda a sexta
                })
                .reduce((total, horaExtra) => total + parseFloat(horaExtra.horas_trabalhadas), 0);
    
            // Calcular horas extras durante o fim de semana (sábado e domingo)
            const horasExtrasFimDeSemana = horasExtrasFiltradas
                .filter(horaExtra => {
                    const dayOfWeek = new Date(horaExtra.data).getDay();
                    return dayOfWeek === 0 || dayOfWeek === 6; // Domingo e sábado
                })
                .reduce((total, horaExtra) => total + parseFloat(horaExtra.horas_trabalhadas), 0);
    
            // Atualizar o estado com as horas extras da semana e do fim de semana
            setHorasExtras({
                totalSemana: horasExtrasSemana,
                totalFimDeSemana: horasExtrasFimDeSemana
            });
    
            // Armazenar as datas das horas extras para marcação no calendário
            const horasExtrasDays = horasExtrasFiltradas.map(horaExtra => new Date(horaExtra.data));
            setHorasExtrasDates(horasExtrasDays);
    
        } catch (error) {
            console.error('Erro ao buscar horas extras:', error);
            setAlert({ open: true, message: 'Erro ao carregar horas extras.', severity: 'error' });
        }
    };
    

    useEffect(() => {
        fetchEmpregados();
        fetchFeriados();
        const faltaDays = document.querySelectorAll('.falta-day');

    const handleDoubleClick = (event) => {
        const date = new Date(event.currentTarget.getAttribute('data-date'));
        handleDateDoubleClick(date);
    };

    faltaDays.forEach((element) => {
        const date = element.parentNode.getAttribute('aria-label');
        element.setAttribute('data-date', date);
        element.addEventListener('dblclick', handleDoubleClick);
    });

    return () => {
        faltaDays.forEach((element) => {
            element.removeEventListener('dblclick', handleDoubleClick);
        });
    };
        
    }, [faltas]);

    const fetchEmpregados = async () => {
        const token = localStorage.getItem('access');
        try {
            const response = await axios.get(`${apiBaseURL}/api/empregados/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setEmpregados(response.data);
        } catch (error) {
            console.error('Erro ao buscar empregados:', error);
            setAlert({ open: true, message: 'Erro ao buscar empregados', severity: 'error' });
        }
    };

    const handleEmpregadoClick = (empregado) => {
        setSelectedEmpregado(empregado);
        console.log(horasExtrasDates);
        setSelectedDates([]); // Limpa os dias selecionados
        fetchHorasExtras(empregado.id, mes, ano);  // Busca as horas extras após selecionar um empregado
        fetchTurnoChanges(empregado.id, ano, mes);
        fetchDiasRestantes(empregado.id, ano); // Usa 'empregado' diretamente em vez de 'selectedEmpregado'
    };
    

    const fetchTurnoChanges = async (empregadoId, ano, mes) => {
        const token = localStorage.getItem('access');
        try {
            const [turnosResponse, feriasResponse, faltasResponse] = await Promise.all([
                axios.get(`${apiBaseURL}/api/turnos/${empregadoId}/${ano}/${mes}/`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }),
                axios.get(`${apiBaseURL}/api/ferias/?empregado=${empregadoId}&ano=${ano}&mes=${mes}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }),
                axios.get(`${apiBaseURL}/api/faltas/?empregado=${empregadoId}&ano=${ano}&mes=${mes}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }),
            ]);
    
            // Armazena os dias de alteração de turno no estado alteradoDays
            const alteredDays = turnosResponse.data.map((change) => new Date(change.data));
            setAlteredDays(alteredDays);  // Salva os dias alterados no estado apropriado
    
            const feriasDays = feriasResponse.data.map(f => new Date(f.dias_ferias));
            const faltasDays = faltasResponse.data.map(f => new Date(f.dia));
    
            setFerias(feriasDays);
            setFaltas(faltasDays);
        } catch (error) {
            setAlert({ open: true, message: 'Erro ao carregar mudanças de turno, férias ou faltas', severity: 'error' });
        }
    };
    

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleSaveFalta = async () => {
        try {
            const token = localStorage.getItem('access');
            const formData = new FormData();
            formData.append('empregado', selectedEmpregado.id);
            formData.append('dia', newFalta.dia);
            formData.append('tipo_falta', newFalta.documento_justificacao ? 'justificada' : 'injustificada');
            formData.append('horario_inicio', newFalta.horario_inicio);
            formData.append('horario_fim', newFalta.horario_fim);
            if (newFalta.documento_justificacao) {
                formData.append('documento_justificacao', newFalta.documento_justificacao);
            }
            await axios.post(`${apiBaseURL}/api/faltas/`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            setAlert({ open: true, message: 'Falta adicionada com sucesso!', severity: 'success' });
            handleCloseModal();
        } catch (error) {
            setAlert({ open: true, message: 'Erro ao adicionar falta', severity: 'error' });
        }
    };

    const handleMarcarFerias = async () => {
        if (!selectedDates.length) {
            setAlert({ open: true, message: 'Selecione os dias primeiro', severity: 'error' });
            return;
        }
    
        // Se "Marcar meio dia" estiver ativo, só pode selecionar um dia
        if (isHalfDay && selectedDates.length > 1) {
            setAlert({ open: true, message: 'Só pode marcar um dia ao selecionar meio dia', severity: 'error' });
            return;
        }
    
        try {
            const token = localStorage.getItem('access');
    
            // Verifica se o empregado tem dias_restantes, caso contrário define como 22
            let diasRestantes = selectedEmpregado.dias_restantes !== undefined ? selectedEmpregado.dias_restantes : 22;
    
            const diasParaDescontar = isHalfDay ? 0.5 : 1; // Descontar meio dia ou um dia inteiro
    
            const payload = selectedDates.map((dia, index) => {
                const novoDiasRestantes = diasRestantes - diasParaDescontar * (index + 1); // Decremento acumulativo
                return {
                    empregado: selectedEmpregado.id,
                    ano: ano,
                    dias_restantes: isHalfDay ? diasRestantes - 0.5 : novoDiasRestantes, // Reduzir corretamente os dias_restantes
                    data_marcada: moment().format('YYYY-MM-DD'),  // Data de hoje
                    aprovado_por: 'Ines',
                    data_aprovacao: moment().format('YYYY-MM-DD'),  // Data de hoje
                    dias_ferias: moment(dia).format('YYYY-MM-DD'),  // Cada dia individualmente
                    half_day: isHalfDay,
                };
            });
    
            // Log do payload
            console.log("Payload para marcar férias:", payload);
    
            await Promise.all(
                payload.map(async (ferias) => {
                    const response = await axios.post(`${apiBaseURL}/api/ferias/`, ferias, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    console.log("Resposta da API para o dia:", ferias.dias_ferias, response.data);
                })
            );
    
            setAlert({ open: true, message: 'Férias marcadas com sucesso!', severity: 'success' });
            fetchTurnoChanges(selectedEmpregado.id, ano, mes); // Atualizar calendário
        } catch (error) {
            // Log da resposta de erro
            console.error("Erro ao marcar férias:", error.response?.data || error.message);
            setAlert({ open: true, message: `Erro ao marcar férias: ${error.response?.data?.detail || error.message}`, severity: 'error' });
        }
    };

    const renderTileContent = ({ date, view }) => {
        if (view === 'month') {
            const isFaltaDay = faltas.find((f) => moment(f.dia).isSame(date, 'day'));
            return (
                <div
                    className={isFaltaDay ? 'falta-day' : ''}
                    style={{ width: '100%', height: '100%' }}
                >
                    {isFaltaDay && (
                        <div
                            className="falta-indicator"
                            style={{ backgroundColor: 'orange', borderRadius: '50%', width: '10px', height: '10px', margin: 'auto' }}
                        />
                    )}
                </div>
            );
        }
        return null;
    };

    const handleDateDoubleClick = (date) => {
        const falta = faltas.find((f) => moment(f.dia).isSame(date, 'day'));
        console.log("click");
        if (falta) {
            setSelectedFalta(falta);
            setFaltaModalOpen(true);
        } else {
            setAlert({ open: true, message: 'Detalhes da falta não encontrados.', severity: 'error' });
        }
    };

    const handleDateClick = (date) => {
        setSelectedDates([date]); // Mantenha a seleção de data
        setNewFalta((prev) => ({
            ...prev,
            dia: moment(date).format('YYYY-MM-DD'), // Formata a data para o campo de falta
        }));
        setNewHoraExtra((prev) => ({
            ...prev,
            data: moment(date).format('YYYY-MM-DD'), // Formata a data para o campo de hora extra
        }));
    
   
        if (isMultiDaySelection) {
            if (!startDate) {
                // Se a data de início não estiver definida, define a data inicial
                setStartDate(date);
                setSelectedDates([date]);  // Seleciona o primeiro dia imediatamente
            } else {
                // Seleciona todos os dias úteis no intervalo entre a data inicial e a data clicada
                const endDate = date;
                const allDates = getWorkingDaysInRange(startDate, endDate);
                setSelectedDates(allDates); // Substitui os dias selecionados com o novo intervalo
                setStartDate(null); // Reinicia a data de início
            }
        } else {
            // Seleção normal (um dia por vez)
            if (selectedDates.find(d => moment(d).isSame(date, 'day'))) {
                // Remove o dia selecionado se ele já estiver na lista
                setSelectedDates(selectedDates.filter(d => !moment(d).isSame(date, 'day')));
            } else {
                // Adiciona o dia à lista de dias selecionados
                setSelectedDates([...selectedDates, date]);
            }
        }
    };

// Função para verificar se um dia é útil (segunda a sexta)
const isWorkingDay = (date) => {
    const dayOfWeek = date.getDay();
    return dayOfWeek !== 0 && dayOfWeek !== 6; // 0 é domingo e 6 é sábado
};

const getWorkingDaysInRange = (start, end) => {
    const range = [];
    let currentDate = new Date(start);

    // Gera o intervalo de dias úteis
    while (currentDate <= end) {
        if (isWorkingDay(currentDate)) {
            range.push(new Date(currentDate));
        }
        currentDate.setDate(currentDate.getDate() + 1); // Avança um dia
    }
    return range;
};

// Ao iniciar a geração, exibe o spinner
const iniciarGeracaoFolhas = async (ano, mes) => {
    setLoading(true); // Abre a modal com spinner
    console.log('Ano:', ano, 'Mes:', mes);
    const token = localStorage.getItem('access');
    try {
      const data = { ano, mes };
      console.log('Dados a serem enviados:', data);
      
      const response = await axios.post(`${apiBaseURL}/api/presenca/gerar/`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRFToken': csrfToken,
        }
      });
      const taskId = response.data.task_id;
      console.log(`Task ID obtido: ${taskId}`);
      acompanharStatusTarefa(taskId, ano, mes);
    } catch (error) {
      console.error('Erro ao iniciar a geração das folhas de presença:', error);
      setAlert({ open: true, message: 'Erro ao iniciar a geração das folhas de presença.', severity: 'error' });
      setLoading(false); // Fecha a modal em caso de erro
      return null;
    }
  };

// Função para verificar o status da tarefa
const verificarStatus = async (taskId) => {
    const token = localStorage.getItem('access');
    try {
      const response = await axios.get(`${apiBaseURL}/api/presenca/status/${taskId}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRFToken': csrfToken,
        },
      });
      return response.data.status; // Ex.: 'PENDING', 'STARTED', 'SUCCESS'
    } catch (error) {
      console.error('Erro ao verificar o status da tarefa:', error);
      setAlert({ open: true, message: 'Erro ao verificar o status da tarefa.', severity: 'error' });
      return null;
    }
  };
  const acompanharStatusTarefa = async (taskId, ano, mes) => {
    const interval = setInterval(async () => {
      const status = await verificarStatus(taskId);
      console.log(`Status atual da tarefa ${taskId}: ${status}`);
      
      if (status === 'SUCCESS') {
        clearInterval(interval); // Para o polling
        setAlert({ open: true, message: 'Folhas de presença geradas com sucesso!', severity: 'success' });
        await handleDownload(ano, mes); // Inicia o download e aguarda sua conclusão
        // O handleDownload deve definir loading como false ao terminar
      } else if (status === 'FAILURE') {
        clearInterval(interval);
        setAlert({ open: true, message: 'Erro ao gerar as folhas de presença.', severity: 'error' });
        setLoading(false);
      }
      // Se o status for PENDING ou STARTED, continua o polling
    }, 3000); // Verifica a cada 3 segundos
  };

// Função para baixar o arquivo ZIP e encerrar o spinner
const handleDownload = async (ano, mes) => {
    const token = localStorage.getItem('access');
    try {
      const response = await axios.get(`${apiBaseURL}/api/presenca/download/${ano}/${mes}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRFToken': csrfToken,
        },
        responseType: 'blob',
      });
    
      const blob = new Blob([response.data], { type: 'application/zip' });
      saveAs(blob, `folhas_de_presenca_${ano}_${mes}.zip`);
      setLoading(false); // Fecha a modal após o download
    } catch (error) {
      console.error('Erro ao baixar as folhas de presença:', error);
      setAlert({ open: true, message: 'Erro ao baixar o arquivo das folhas de presença.', severity: 'error' });
      setLoading(false);
    }
  };


const performBackendOperation = async () => {
    // Simula uma função de backend (podes substituir pelo teu request real)
    return new Promise((resolve) => setTimeout(resolve, 5000)); // Simulação de 5 segundos
};


// Função para salvar as alterações de turno
const handleSaveChanges = async () => {
    const token = localStorage.getItem('access');
    const csrftoken = document.cookie
        .split('; ')
        .find(row => row.startsWith('csrftoken'))
        ?.split('=')[1];

    try {
        const payload = {
            empregado_id: selectedEmpregado.id,
            ano,
            mes,
            dias: selectedDates.map(date => moment(date).format('YYYY-MM-DD')),  // Converter datas para strings no formato correto
            turno,  // Turno selecionado
        };

        console.log("Payload de alteração de turno:", payload);

        await axios.post(`${apiBaseURL}/api/salvar-turno/`, payload, {
            headers: {
                'X-CSRFToken': csrftoken,
                'Authorization': `Bearer ${token}`,
            },
        });
        setAlert({ open: true, message: 'Mudanças de turno salvas com sucesso', severity: 'success' });

        if (!empregadosAlterados.includes(selectedEmpregado.id)) {
            setEmpregadosAlterados([...empregadosAlterados, selectedEmpregado.id]);
        }
    } catch (error) {
        console.error('Erro ao salvar alterações de turno:', error.response?.data || error.message);
        setAlert({ open: true, message: 'Erro ao salvar alterações de turno', severity: 'error' });
    }
};

const handleFullDayChange = (e) => {
    const isChecked = e.target.checked;
    setIsFullDay(isChecked);

    if (isChecked && selectedEmpregado) {
        // Preencher os horários de início e fim com base no turno do empregado
        switch (selectedEmpregado.turno) {
            case 'manha-1':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '05:00',
                    horario_fim: '13:00',
                });
                break;
            case 'manha':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '06:00',
                    horario_fim: '14:00',
                });
                break;
            case 'tarde':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '14:00',
                    horario_fim: '22:00',
                });
                break;
            case 'noite':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '22:00',
                    horario_fim: '06:00',
                });
                break;
            case 'normal':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '09:00',
                    horario_fim: '18:00',
                });
                break;
            case 'horario_amamentacao':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '11:00',
                    horario_fim: '18:00',
                });
                break;
            default:
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '',
                    horario_fim: '',
                });
                break;
        }
    } else {
        // Limpar os horários se o checkbox for desmarcado
        setNewFalta({
            ...newFalta,
            horario_inicio: '',
            horario_fim: '',
        });
    }
};

const fetchDiasRestantes = async (empregadoId, ano) => {
    const token = localStorage.getItem('access');
    try {
        const response = await axios.get(`${apiBaseURL}/api/ferias/?empregado=${empregadoId}&ano=${ano}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.data.length > 0) {
            // Encontra o último registro de férias com base no maior ID
            const feriasMaisRecente = response.data.reduce((prev, current) => {
                return (prev.id > current.id) ? prev : current; // Compara os IDs para garantir que o mais recente seja o maior
            });

            setSelectedEmpregado(prev => ({
                ...prev,
                dias_restantes: feriasMaisRecente.dias_restantes
            }));
        } else {
            setSelectedEmpregado(prev => ({
                ...prev,
                dias_restantes: 22 // Valor padrão se não houver férias registradas
            }));
        }
    } catch (error) {
        console.error('Erro ao buscar os dias restantes de férias:', error);
    }
};

const handleSearchChange = (event) => {
    setSearchTerm(event.target.value); // Atualiza o termo de pesquisa conforme o usuário digita
};
// Filtrar a lista de empregados com base no termo de pesquisa
const filteredEmpregados = empregados.filter((empregado) =>
    empregado.nome_completo.toLowerCase().includes(searchTerm.toLowerCase())
);

const getTileClassName = ({ date }) => {
    const dayOfWeek = date.getDay();
    const monthInDropdown = mes - 1; // Mês selecionado, -1 porque Date usa 0 para janeiro
    const yearInDropdown = ano; // Ano selecionado

    // Verifica se a data pertence ao mês e ano selecionados nas dropdowns
    if (date.getMonth() === monthInDropdown && date.getFullYear() === yearInDropdown) {
        if (selectedDates.find(d => moment(d).isSame(date, 'day'))) {
            return 'selected-day';  // Dias com turnos selecionados em azul
        }
        if (ferias.find(f => moment(f).isSame(date, 'day'))) {
            return 'ferias-day';  // Dias de férias em vermelho
        }
        if (faltas.find(f => moment(f).isSame(date, 'day'))) {
            return 'falta-day';  // Dias de faltas em laranja
        }
        if (alteredDays.find(a => moment(a).isSame(date, 'day'))) {
            return 'turno-alterado-day';  // Dias com alteração de turno em verde escuro
        }
        if (feriados.find(f => moment(f.date).isSame(date, 'day'))) {  // Verifica os feriados da base de dados
            return 'feriado-day';  // Dias de feriados em uma cor diferente, por exemplo, roxo
        }
        if (horasExtrasDates.find(h => moment(h).isSame(date, 'day'))) {
            return 'horas-extras-day'; // Dias com horas extras em azul clarinho
        }
        if (manualHolidays.find(h => moment(h).isSame(date, 'day'))) {
            return 'feriado-manual-day';  // Feriados marcados manualmente
        }
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            return 'normal-day';  // Dias úteis (segunda a sexta) em verde claro
        }
    }

    return '';  // Finais de semana ou dias fora do mês/ano selecionado sem cor específica
};

    return (
        <Box sx={{ display: 'flex', height: '100vh', width: '100%' }}>
    
    <Box sx={{ width: '20%', p: 2, borderRight: '1px solid grey', overflowY: 'auto', height: '100vh' }}>
        <Typography variant="h6">Empregados</Typography>
        
        {/* Caixa de pesquisa */}
        <TextField
            label="Procurar Empregado"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{ mb: 2 }}
            placeholder="Procurar"
        />
        
        {/* Define uma altura fixa para a lista e permite o scroll quando necessário */}
        <Box sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <TableContainer>
                <Table>
                    <TableBody>
                        {filteredEmpregados.map((empregado) => (
                            <TableRow
                                key={empregado.id}
                                onClick={() => {
                                    handleEmpregadoClick(empregado);
                                    setSelectedDates([]); // Limpa os dias selecionados ao selecionar um novo empregado
                                }}
                                sx={{
                                    cursor: 'pointer',
                                    backgroundColor: selectedEmpregado?.id === empregado.id ? '#1976d2' : 'white', // Aplica azul claro ao empregado selecionado
                                }}
                            >
                                <TableCell>{empregado.nome_completo}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>

        <Button 
  variant="contained" 
  color="primary" 
  onClick={() => iniciarGeracaoFolhas(ano, mes)} 
    startIcon={<Download />}
>
  Download Alterações
</Button>
    </Box>

            <Box sx={{ flex: 1, p: 2 }}>
                
            {selectedEmpregado && (
    <>
        <Typography variant="h2" sx={{ mb: 2 }}>
            Empregado: {selectedEmpregado.nome_completo}
        </Typography>
        <Typography variant="h6" sx={{ mb: 2 }}>
            Dias restantes de férias: {selectedEmpregado.dias_restantes}
        </Typography>
        <Typography variant="h6" sx={{ mb: 2 }}>
    Turno alocado por defeito: {selectedEmpregado.turno}
</Typography>
    </>
)}

    
    <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={6}>
            <FormControl fullWidth>
                <InputLabel>Ano</InputLabel>
                <Select
                    value={ano}
                    onChange={(e) => setAno(e.target.value)}
                >
                    {years.map((y) => (
                        <MenuItem key={y} value={y}>
                            {y}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>
        <Grid item xs={6}>
        <FormControl fullWidth>
    <InputLabel>Mês</InputLabel>
    <Select
        value={mes}
        onChange={(e) => setMes(e.target.value)}
    >
        {moment.months().map((m, index) => (
            <MenuItem key={index} value={index + 1}>
                {m} {/* Exibir o nome do mês em português */}
            </MenuItem>
        ))}
    </Select>
</FormControl>
        </Grid>
    </Grid>
            <Button style={{marginbottom: '3em', marginLeft: '5em', marginRight:'1em'}} variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleOpenModal}>
                            Adicionar Falta
                        </Button>
                        <Button  variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleOpenAddModal}>
    Adicionar Horas Extra
</Button>


                        
<Grid container spacing={3} style={{ marginBottom: '30em', marginLeft: '5em', marginTop: '0.21em', alignContent: 'space-between' }}>
    {/* Coluna para o calendário */}
    <Grid item xs={9}>
    <Calendar
    onClickDay={handleDateClick}
    value={new Date(ano, mes - 1)}
    tileClassName={getTileClassName}
    tileContent={renderTileContent}
/>
    </Grid>

    {/* Coluna para o título (h6) */}
    <Grid item xs={3}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={isMultiDaySelection}
                            onChange={(e) => setIsMultiDaySelection(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Selecionar vários dias úteis"
                />
                <Button
                variant="contained"
                color="secondary"
                onClick={handleMarkHoliday}  // Função que marca o feriado
                sx={{ mt: 2 }}
            >
                Marcar como Feriado
            </Button>
            <div>
        <FormControlLabel
            control={
                <Checkbox
                    checked={isHalfDay}
                    onChange={(e) => setIsHalfDay(e.target.checked)}
                    color="primary"
                />
            }
            label="Marcar meio dia"
        />
        <Button onClick={handleMarcarFerias} variant="contained" color="primary">
            Marcar Férias
        </Button>
        {/* Label para Total de Horas Extras da Semana */}
    <Typography variant="h6" sx={{ mt: 2 }}>
        Total de Horas Extras da Semana: {horasExtras.totalSemana}h
    </Typography>

    {/* Label para Total de Horas Extras do Fim de Semana */}
    <Typography variant="h6" sx={{ mt: 2 }}>
        Total de Horas Extras do Fim de Semana: {horasExtras.totalFimDeSemana}h
    </Typography>
    </div>
            </Grid>

    {/* Marcar Férias Button */}
    <Grid item xs={12}>
        <Button variant="contained" color="primary" sx={{ mt: 2, ml: 2 }} onClick={handleMarcarFerias}>
            Marcar dias selecionados de Férias
        </Button>
    </Grid>

    {/* Legenda */}
    <Grid item xs={12}>
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', maxWidth: '100%', marginTop: '1em' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 2 }}>
                <Box sx={{ width: 20, height: 20, backgroundColor: 'red', mr: 1 }}></Box>
                <Typography>Férias</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 2 }}>
                <Box sx={{ width: 20, height: 20, backgroundColor: 'rgb(223, 145, 0)', mr: 1 }}></Box>
                <Typography>Falta</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 2 }}>
                <Box sx={{ width: 20, height: 20, backgroundColor: 'lightgreen', mr: 1 }}></Box>
                <Typography>Dia normal</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 2 }}>
                <Box sx={{ width: 20, height: 20, backgroundColor: 'darkgreen', mr: 1 }}></Box>
                <Typography>Alterações do turno</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 2 }}>
                <Box sx={{ width: 20, height: 20, backgroundColor: 'white', mr: 1 }}></Box>
                <Typography>Feriado</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 2 }}>
                <Box sx={{ width: 20, height: 20, backgroundColor: '#ADD8E6', mr: 1 }}></Box>
                <Typography>Dia com horas extra</Typography>
            </Box>
        </Box>
    </Grid>
    <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item xs={6}>
                        <FormControl fullWidth>
                            <InputLabel>Turno</InputLabel>
                            <Select
                                value={turno}
                                onChange={(e) => setTurno(e.target.value)}
                            >
                                <MenuItem value="normal">Normal</MenuItem>
                                <MenuItem value="manha">Manhã</MenuItem>
                                <MenuItem value="tarde">Tarde</MenuItem>
                                <MenuItem value="noite">Noite</MenuItem>
                                <MenuItem value="manha-1">Manhã-1</MenuItem>
                                <MenuItem value="horario_amamentacao">Horário de Amamentação</MenuItem>
                                <MenuItem value="horario_amamentacao_tarde">Horário de Amamentação Tarde</MenuItem>
                                <MenuItem value="horario_amamentacao_manha_tarde">Horário de Amamentação Manhã Tarde</MenuItem>
                                <MenuItem value="horario_amamentacao_1_tarde">Horário de Amamentação -1 Tarde</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSaveChanges}
                            sx={{ mt: 2 }}
                        >
                            Guardar Alterações
                        </Button>
                    </Grid>
                </Grid>
</Grid>


                
            </Box>

            <Snackbar
                open={alert.open}
                autoHideDuration={6000}
                onClose={() => setAlert({ ...alert, open: false })}
            >
                <Alert onClose={() => setAlert({ ...alert, open: false })} severity={alert.severity}>
                    {alert.message}
                </Alert>
            </Snackbar>

            {/* Modal de Loading */}
            <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <CircularProgress color="inherit" />
                    <Typography variant="h6" sx={{ mt: 2 }}>
                        Estou a preencher os dados solicitados...
                    </Typography>
                </Box>
            </Backdrop>

            {/* Alertas */}
            <Snackbar
                open={alert.open}
                autoHideDuration={6000}
                onClose={() => setAlert({ ...alert, open: false })}
            >
                <Alert onClose={() => setAlert({ ...alert, open: false })} severity={alert.severity}>
                    {alert.message}
                </Alert>
            </Snackbar>
        

            <Modal open={modalOpen} onClose={handleCloseModal}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
                    <Typography id="modal-title" variant="h6" component="h2">
                        Adicionar Falta
                    </Typography>
                    <TextField
                        label="Empregado"
                        fullWidth
                        margin="normal"
                        value={selectedEmpregado?.nome_completo || ''}
                        disabled
                    />
                    <TextField
                        label="Dia"
                        type="date"
                        name="dia"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        value={newFalta.dia}
                        onChange={(e) => setNewFalta({ ...newFalta, dia: e.target.value })}
                    />
                    <FormControlLabel
    control={
        <Checkbox
            checked={isFullDay}
            onChange={handleFullDayChange}
            color="primary"
        />
    }
    label="Dia inteiro"
/>
                    <TextField
                        label="Horário de Início"
                        type="time"
                        name="horario_inicio"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        value={newFalta.horario_inicio}
                        disabled={isFullDay}
                        onChange={(e) => setNewFalta({ ...newFalta, horario_inicio: e.target.value })}
                    />
                    <TextField
                        label="Horário de Fim"
                        type="time"
                        name="horario_fim"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        value={newFalta.horario_fim}
                        disabled={isFullDay}
                        onChange={(e) => setNewFalta({ ...newFalta, horario_fim: e.target.value })}
                    />
                    <Button
                        variant="contained"
                        component="label"
                        color="primary"
                        fullWidth
                        sx={{ mt: 2 }}
                    >
                        Anexar Documento de Justificação
                        <input
                            type="file"
                            hidden
                            onChange={(e) => setNewFalta({ ...newFalta, documento_justificacao: e.target.files[0] })}
                        />
                    </Button>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
                        <Button onClick={handleCloseModal} variant="contained" color="secondary">
                            Cancelar
                        </Button>
                        <Button onClick={handleSaveFalta} variant="contained" color="primary">
                            Salvar Falta
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Modal
    open={openAddModal}
    onClose={handleCloseModals}
    aria-labelledby="modal-add-hora-extra"
    aria-describedby="modal-add-hora-extra-description"
>
    <Box
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
        }}
    >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6">
                Adicionar Hora Extra para {selectedEmpregado?.nome_completo}
            </Typography>
            <IconButton onClick={handleCloseModals}>
                <Close />
            </IconButton>
        </Box>
        <TextField
            label="Data"
            type="date"
            name="data"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={newHoraExtra.data}
            onChange={handleNewHoraExtraChange}
            inputProps={{
                max: moment().format('YYYY-MM-DD'),
            }}
        />
        <TextField
            label="Horas Trabalhadas"
            type="number"
            name="horas_trabalhadas"
            fullWidth
            margin="normal"
            InputProps={{ inputProps: { min: 0.5, step: 0.5 } }}
            value={newHoraExtra.horas_trabalhadas}
            onChange={handleNewHoraExtraChange}
        />
        <TextField
            style={{ display: 'none' }}  // Corrigido: style como objeto e chave 'display' entre chaves duplas

            label="Justificação"
            name="justificativa"
            fullWidth
            margin="normal"
            multiline
            rows={4}
            value={newHoraExtra.justificativa}
            onChange={handleNewHoraExtraChange}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button variant="contained" color="primary" onClick={handleAddHoraExtra}>
                Adicionar
            </Button>
        </Box>
    </Box>
</Modal>
<Modal
    open={isHolidayModalOpen}
    onClose={handleCloseHolidayModal}
    aria-labelledby="holiday-modal-title"
    aria-describedby="holiday-modal-description"
>
    <Box
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2
        }}
    >
        <Typography id="holiday-modal-title" variant="h6" component="h2">
            Inserir o nome do Feriado
        </Typography>
        <TextField
            label="Nome do Feriado"
            fullWidth
            value={holidayName}
            onChange={(e) => setHolidayName(e.target.value)}
            margin="normal"
        />
        <Button
            variant="contained"
            color="primary"
            onClick={handleSaveHoliday}
            sx={{ mt: 2 }}
        >
            Salvar Feriado
        </Button>
        <Button
            variant="contained"
            color="secondary"
            onClick={handleCloseHolidayModal}
            sx={{ mt: 2, ml: 2 }}
        >
            Cancelar
        </Button>
    </Box>
</Modal>
<Modal
    open={faltaModalOpen}
    onClose={() => setFaltaModalOpen(false)}
    aria-labelledby="falta-modal-title"
    aria-describedby="falta-modal-description"
>
    <Box
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
        }}
    >
        <Typography id="falta-modal-title" variant="h6" component="h2">
            Detalhes da Falta
        </Typography>
        {selectedFalta && (
            <>
                <Typography>Dia: {moment(selectedFalta).format('DD/MM/YYYY')}</Typography>
                <Button
                    variant="contained"
                    component="label"
                    color="primary"
                    fullWidth
                    sx={{ mt: 2 }}
                >
                    Carregar Justificação
                    <input
                        type="file"
                        hidden
                        onChange={(e) => setNewFalta({ ...newFalta, documento_justificacao: e.target.files[0] })}
                    />
                </Button>
            </>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
            <Button onClick={() => setFaltaModalOpen(false)} variant="contained" color="secondary">
                Fechar
            </Button>
        </Box>
    </Box>
</Modal>

        </Box>
    );
};

export default Folhasdepresençav2;
